/**
 * Creates an object by mapping a set of keys to values using the given function.
 */
export function makeObject<K extends string | number | symbol, V>(
  makeValue: (key: K) => V,
  ...keys: K[]
): { [k in K]: V } {
  const result: { [k in K]?: V } = {};

  keys.forEach((k) => (result[k] = makeValue(k)));

  /* Type assertion required since result has optional properties. */
  return result as { [k in K]: V };
}
